import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../../guards/auth.guard";
import { NgModule } from "@angular/core";
import { SelectCompanyComponent } from "./components/select-company.component";

const routes: Routes = [
  {
    path: "selecionar-empresa",
    component: SelectCompanyComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectCompanyRoutingModule {}
